// Planner Season: countdown timers + gentle reveal-on-scroll. No dependencies.
(() => {
  const pad = (n) => String(n).padStart(2, "0");
  document.querySelectorAll("[data-ps-countdown]").forEach((el) => {
    const target = new Date(el.dataset.psCountdown);
    const out = { d: el.querySelector("[data-d]"), h: el.querySelector("[data-h]"), m: el.querySelector("[data-m]"), s: el.querySelector("[data-s]") };
    const tick = () => {
      const diff = target - Date.now();
      if (Number.isNaN(diff) || diff <= 0) { el.hidden = true; return false; }
      const s = Math.floor(diff / 1000);
      out.d.textContent = pad(Math.floor(s / 86400));
      out.h.textContent = pad(Math.floor((s % 86400) / 3600));
      out.m.textContent = pad(Math.floor((s % 3600) / 60));
      out.s.textContent = pad(s % 60);
      return true;
    };
    if (tick()) setInterval(tick, 1000);
  });

  if (!("IntersectionObserver" in window) || matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.remove("ps-hide"); io.unobserve(e.target); } });
  }, { rootMargin: "0px 0px -8% 0px" });
  document.querySelectorAll(".ps-reveal").forEach((el) => {
    if (el.getBoundingClientRect().top > innerHeight) { el.classList.add("ps-hide"); io.observe(el); }
  });
})();
